<template>
  <div
    class="relative w-full rounded border-2 border-dashed border-[#D1D3D8] bg-white py-16"
    :class="{ 'border-teal-400 bg-teal-50': containerActive }"
    @drop.prevent="onDrop"
    @dragenter.prevent="
      removeContainerActivity = false;
      dropActive = true;
    "
    @dragleave.prevent="dropActive = false"
    @dragover.prevent="
      removeContainerActivity = false;
      dropActive = true;
    "
  >
    <div
      class="absolute right-1/2 top-1/2 w-4/5 -translate-y-1/2 translate-x-1/2 transform"
    >
      <div class="mb-0 flex flex-col items-center justify-center gap-y-2.5">
        <h2
          v-if="!containerActive"
          class="text-lg font-semibold text-[#1A242A]"
        >
          Drag and drop file or
          <span
            class="cursor-pointer text-[#0667C0] underline"
            @click="triggerInput"
          >Browse
          </span>
          to upload
        </h2>
        <CloudUpload
          v-else
          :class="uploadIconStyle"
          @click="triggerInput"
        />
        <input
          ref="fileInput"
          type="file"
          class="hidden"
          @change="receiveFileFromInput"
        >
        <slot :active="containerActive" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropFileInput',

  props: {
    uploadIconStyle: {
      type: String,
      default: 'text-[#198661] h-16 w-17',
    },
    fileList: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['file-dropped'],

  data() {
    return {
      events: ['dragenter', 'dragleave', 'dragover', 'drop'],
      dropActive: false,
      removeContainerActivity: false,
    }
  },

  computed: {
    containerActive() {
      return this.dropActive && !this.removeContainerActivity
    },
  },

  watch: {
    fileList: {
      handler(newFiles, oldFiles) {
        this.removeContainerActivity
          = oldFiles?.length - newFiles?.length === 1
      },
      immediate: true,
    },
  },

  mounted() {
    this.events.forEach(eventName =>
      document.body.addEventListener(eventName, this.preventDefaults),
    )
  },

  beforeUnmount() {
    this.events.forEach(eventName =>
      document.body.removeEventListener(eventName, this.preventDefaults),
    )
  },

  methods: {
    onDrop(event) {
      this.dropActive = true
      this.$emit('file-dropped', [...event.dataTransfer.files])
    },
    preventDefaults(event) {
      event.preventDefault()
    },
    triggerInput() {
      this.dropActive = false
      this.removeContainerActivity = false
      this.$refs.fileInput.click()
    },
    receiveFileFromInput(event) {
      const files = [...event.target.files]
      if (files.length) {
        this.$emit('file-dropped', files)
        this.dropActive = true
        event.target.files = null
      }
    },
  },
}
</script>
